import { insertContent } from 'hubspot-prosemirror/prosemirror/utils/documentUtils';
import { useEffect, useState } from 'react';
import usePrevious from 'react-utils/hooks/usePrevious';
import { trackEvent } from '../../../usage-tracking/clients/usageTracker';
import { replyRecEdited, replyRecSeen, replyRecVisibility } from '../events/ReplyRecommendationEvents';
import { useCurrentReplyRecommendation } from '../hooks/useCurrentReplyRecommendation';
import { ReplyRecommendation } from './ReplyRecommendation';
import { useReplyRecommendationsConfig } from '../hooks/useReplyRecommendationsConfig';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ReplyRecommendationManager = ({
  editorState,
  setEditorState,
  threadId
}) => {
  var _editorState$doc;
  const {
    currentReplyRecommendation,
    currentReplyRecInResponseTo
  } = useCurrentReplyRecommendation({
    threadId
  });
  const {
    isReplyRecOpen,
    setIsReplyRecOpen
  } = useReplyRecommendationsConfig({
    threadId
  });
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => setHasMounted(true), [setHasMounted]);
  const hasEditorContent = Boolean(((editorState === null || editorState === void 0 || (_editorState$doc = editorState.doc) === null || _editorState$doc === void 0 || (_editorState$doc = _editorState$doc.firstChild) === null || _editorState$doc === void 0 || (_editorState$doc = _editorState$doc.content) === null || _editorState$doc === void 0 ? void 0 : _editorState$doc.size) || 0) > 2);
  const prevReplyRecommendation = usePrevious(currentReplyRecommendation);
  const displayedAfterLoad = Boolean(hasMounted && !prevReplyRecommendation && currentReplyRecommendation);
  const onReplyRecEdit = () => {
    if (currentReplyRecommendation) {
      const {
        confidenceScore
      } = currentReplyRecommendation;
      trackEvent(replyRecEdited({
        inResponseToMessageId: currentReplyRecInResponseTo,
        confidenceScore,
        hasEditorContent,
        displayedAfterLoad
      }));
      setEditorState(insertContent({
        htmlBody: (currentReplyRecommendation === null || currentReplyRecommendation === void 0 ? void 0 : currentReplyRecommendation.richText) || (currentReplyRecommendation === null || currentReplyRecommendation === void 0 ? void 0 : currentReplyRecommendation.text) || '',
        editorState,
        from: 1,
        to: 1
      }));
      setIsReplyRecOpen(false);
    }
  };
  const onReplyRecDismiss = () => {
    setIsReplyRecOpen(false);
    trackEvent(replyRecVisibility('dismiss'));
  };
  useEffect(() => {
    if (currentReplyRecommendation && !prevReplyRecommendation) {
      const {
        confidenceScore
      } = currentReplyRecommendation;
      setIsReplyRecOpen(true);
      trackEvent(replyRecSeen({
        inResponseToMessageId: currentReplyRecInResponseTo,
        confidenceScore,
        hasEditorContent,
        displayedAfterLoad
      }));
    }
  }, [currentReplyRecommendation, currentReplyRecInResponseTo, setIsReplyRecOpen, hasEditorContent, displayedAfterLoad, prevReplyRecommendation]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isReplyRecOpen && currentReplyRecommendation && /*#__PURE__*/_jsx(ReplyRecommendation, {
      onEdit: onReplyRecEdit,
      onDismiss: onReplyRecDismiss,
      currentReplyRecommendation: currentReplyRecommendation
    })
  });
};
ReplyRecommendationManager.displayName = 'ReplyRecommendationManager';